import { Component, Input, OnInit } from '@angular/core';
import { ApplicationStatusInfo } from '../../../applications/application-models/ApplicationStatusInfo';
import { ApplicationCounts } from '../../../../shared/models/EvoSalesPortalModel';
import { DashboardService } from '../../../../shared/services/dashboard.service';
import { Router } from '@angular/router';
import { BindingContext } from '../../../../shared/models/BindingContext';
import { DashboardWidget } from '../../dashboard-interface';

@Component({
    selector: 'app-dashboard-apps',
    templateUrl: './dashboard-apps.component.html',
    styleUrls: ['./dashboard-apps.component.scss'],
    host: { 'class': 'col-md-6 col-lg-4' }
})
export class DashboardAppsComponent extends DashboardWidget implements OnInit {
    @Input() title: string;
    @Input() color = 'white';
    @Input() url: string;
    @Input() bindingContext:BindingContext;

    public appCounts: ApplicationCounts;
	private dashboardError: string = "Error loading dashboard item, please contact support."
    constructor(private dashSvc: DashboardService, private router: Router) {
        super();
        this.appCounts = new ApplicationCounts();
    }
    ngOnInit() {
        this.GetData();
    }
    public RowClick(interval:string) {
        //console.log("ROW CLICKED");
        this.router.navigate(['/applications/Complete/' + interval]);
    }

    public GetData() {
        this.bindingContext.beginGet();
        this.dashSvc.getMerchantAppCounts()
            .toPromise()
            .then((resp: ApplicationCounts) => {
                this.appCounts = resp;
                this.bindingContext.endGet();
            })
            .catch(response => {
                this.bindingContext.endGet();
                this.bindingContext.showAlert(BindingContext.alertType.danger, this.dashboardError,true);
            });
    }
}

